module.exports = __webpack_public_path__ + "static/media/21.47171cd0.svg";